import { Component, OnInit } from '@angular/core';
import { RecaptchaErrorParameters } from "ng-recaptcha"
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PartnersTunaService } from '../../contexts/partners/partners-tuna.service';
import { CpfCnpjValidator } from '../../core/utils/cpf-cnpj.validator';
import { Title } from '@angular/platform-browser';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';
import { ActivatedRoute, Router } from "@angular/router";
import { KeycloakService } from 'keycloak-angular';
import { AppConfigService } from 'src/app/app-config.service';

@Component({
  selector: 'app-login-google',
  templateUrl: './login-google.component.html',
  styleUrls: ['./login-google.component.scss']
})
export class LoginGoogleComponent implements OnInit {

  model: any = {};

  constructor(
    private translateService: TranslateService,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private config: AppConfigService,
    private keycloakService: KeycloakService) { }

  async ngOnInit() {
    this.translateService.use("pt-br");
    this.titleService.setTitle('Console • Tuna');


    this.route.paramMap.subscribe(params => {
      this.model.partner = params.get('partner');

      var config = this.config.getConfig();

      this.keycloakService
        .init({
          config: {
            url: config.url,
            realm: this.model.partner,
            clientId: 'tuna-console',
          },
          initOptions: {
            onLoad: 'check-sso',
          }
        })
        .then((authenticated) => {

          if (authenticated) {
            this.router.navigateByUrl('/' + this.model.partner);
          }
        })
    });

  }

  async login() {

    const url = new URL(window.location.href);
    const hint = url.pathname.split('/')[3];

    var config = this.config.getConfig();

    await this.keycloakService
      .init({
        config: {
          url: config.url,
          realm: this.model.partner,
          clientId: 'tuna-console',
        },
        initOptions: {
          // this will solved the error
          checkLoginIframe: false
        }
      })
      .then(() => {
        console.log(
          'login com ' + hint + ' ' + this.model.partner
        );

        var url = this.keycloakService
          .getKeycloakInstance()
          .createLoginUrl({
            idpHint: hint,
            redirectUri:
              config.urlConsole +
              this.model.partner
          });

        window.open(url, '_blank');
      });
  }

}
